export default __webpack_public_path__ + "static/cruiselines-royal-ship-4-09e3fb9ba6ca5f10cfc3b2aebb64a7a7.jpg";